import React, { useState } from "react"
import "./team.sass"
import { defaultIntl, Slider, window } from "../../utils"

// images
import Pic0 from "../../images/driver/driver0.jpg"
import Pic1 from "../../images/driver/driver1.jpg"
import Pic2 from "../../images/driver/driver2.jpg"

const getSliderList = intl => [
  <div className="column">
    <div className="text-content">
      <p>{intl.formatMessage({ id: "driver.meet.a.desc" })}</p>
    </div>
    <div className="media">
      <div className="media-left">
        <figure className="image is-74x74">
          <img src={Pic0} alt="" />
        </figure>
      </div>
      <div className="media-content">
        <h3>{intl.formatMessage({ id: "driver.meet.a.title" })}</h3>
        <p>{intl.formatMessage({ id: "driver.meet.a.exp" })}</p>
      </div>
    </div>
  </div>,
  <div className="column">
    <div className="text-content">
      <p>{intl.formatMessage({ id: "driver.meet.b.desc" })}</p>
    </div>
    <div className="media">
      <div className="media-left">
        <figure className="image is-74x74">
          <img src={Pic1} alt="" />
        </figure>
      </div>
      <div className="media-content">
        <h3>{intl.formatMessage({ id: "driver.meet.b.title" })}</h3>
        <p>{intl.formatMessage({ id: "driver.meet.b.exp" })}</p>
      </div>
    </div>
  </div>,
  <div className="column">
    <div className="text-content">
      <p>{intl.formatMessage({ id: "driver.meet.c.desc" })}</p>
    </div>
    <div className="media">
      <div className="media-left">
        <figure className="image is-74x74">
          <img src={Pic2} alt="" />
        </figure>
      </div>
      <div className="media-content">
        <h3>{intl.formatMessage({ id: "driver.meet.c.title" })}</h3>
        <p>{intl.formatMessage({ id: "driver.meet.c.exp" })}</p>
      </div>
    </div>
  </div>,
  <div className="column">
    <div className="text-content">
      <p>{intl.formatMessage({ id: "driver.meet.d.desc" })}</p>
    </div>
    <div className="media">
      <div className="media-left">
        <figure className="image is-74x74">
          <img src={Pic1} alt="" />
        </figure>
      </div>
      <div className="media-content">
        <h3>{intl.formatMessage({ id: "driver.meet.d.title" })}</h3>
        <p>{intl.formatMessage({ id: "driver.meet.d.exp" })}</p>
      </div>
    </div>
  </div>,
]

export default ({ intl = defaultIntl }) => {
  const [slider, setSlider] = useState(null)
  const [current, setCurrent] = useState(0)
  const isMobile = window.isMobile()
  console.log("isMobile", isMobile)
  const SliderList = getSliderList(intl)
  const SliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    autoplay: true,
    slidesToShow: isMobile ? 1 : 2,
    slidesToScroll: 1,
    // fade: 1,
    afterChange: cur => {
      setCurrent(cur)
    },
  }

  const cusors = new Array(Math.ceil(SliderList.length / SliderSettings.slidesToShow)).fill("")
  if (!isMobile) {
    cusors.push("")
    cusors.push("")
  }
  const handlerSwitch = i => {
    let item = document.querySelector(".current")
    if (item) {
      item.classList.remove("current")
    }
    slider.slickGoTo(i)
  }

  return (
    <div className="team">
      <div className="container" style={{ border: 0, overflow: "visible" }}>
        <div className="text-content centered">
          <h2>{intl.formatMessage({ id: "driver.meet.title" })}</h2>
        </div>
      </div>
      <div className="switch-wrap">
        <div className="container" style={{ border: 0, overflow: "visible", position: "relative", zIndex: 9, backgroundColor: "transparent" }}>
          <div className="slider-controll">
            {cusors.map((s, i) => {
              const sliderClass = ["slider-indicator"]
              if (i === current) {
                sliderClass.push("current")
              }
              return <span className={sliderClass.join(" ")} onClick={() => handlerSwitch(i)} onMouseOver={() => handlerSwitch(i)} key={i} />
            })}
          </div>
        </div>
        <div className="container slider-main">
          <Slider {...SliderSettings} ref={slider => setSlider(slider)}>
            {SliderList.map((slider, index) => {
              return (
                <div className="slide-item" key={index}>
                  <div className="columns is-vcentered">{slider}</div>
                </div>
              )
            })}
          </Slider>
        </div>
      </div>
    </div>
  )
}
